import { usePage } from "@inertiajs/react"

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { useInitials } from "@/hooks/use-initials"
import type { Account, Auth, User } from "@/types"

export function UserInfo({
  user,
  showEmail = false,
}: {
  user: User
  showEmail?: boolean
}) {
  const getInitials = useInitials()
  const { auth, account } = usePage().props as unknown as {
    auth: Auth
    account?: Account
  }
  // The `account` shared prop is the signed-in user's workspace in the
  // client app. On admin pages a page prop named `account` is the record
  // being viewed (e.g. the account detail page), not the admin's workspace,
  // so only use it for user-type sessions.
  const workspaceName = auth.type === "user" ? (account?.name ?? "") : ""
  const secondary = showEmail ? user.email : workspaceName

  return (
    <>
      <Avatar className="h-8 w-8 overflow-hidden rounded-full">
        <AvatarImage src={user.avatar_url} alt={user.name} />
        <AvatarFallback className="rounded-lg bg-neutral-200 text-black dark:bg-neutral-700 dark:text-white">
          {getInitials(user.name)}
        </AvatarFallback>
      </Avatar>
      <div className="grid flex-1 text-left text-sm leading-tight">
        <span className="truncate font-medium">{user.name}</span>
        {secondary && (
          <span className="text-muted-foreground truncate text-xs">
            {secondary}
          </span>
        )}
      </div>
    </>
  )
}
